/* @import '../../../node_modules/flickity/css/flickity.css'; */
@import '../../../node_modules/swiper/swiper-bundle.min.css';

:host {
  display: block;
}

.flickity-button:disabled {
  display: none;
}

.flickity-prev-next-button {
  width: 40px;
  height: 40px;
}

.flickity-prev-next-button.next {
  right: 6px;
}

.flickity-prev-next-button.prev {
  left: 6px;
}
.carousel-cell {
  margin-right: 5px;
  margin-left: 5px;
}
.swiper-slide {
  width: 272px !important;
}

.swiper-button-next, .swiper-button-prev {
  background: rgba(45, 45, 45, 0.7) !important;
  color: #fff !important;
  border: 1px solid #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  top: calc(50% - 10px);
}

.swiper-button-prev:after, .swiper-rtl .swiper-button-next:after {
  content: " ";
  border-left: 1px solid #fff;
  border-bottom: 1px solid #fff;
  width: 7px;
  height: 7px;
  transform: rotate(45deg);
  cursor: pointer;
  display: block;
  margin-right: -2px;
}

.swiper-button-next:after, .swiper-rtl .swiper-button-prev:after {
  content: " ";
  border-right: 1px solid #fff;
  border-top: 1px solid #fff;
  width: 7px;
  height: 7px;
  transform: rotate(45deg);
  cursor: pointer;
  display: block;
  margin-left: -2px;
}

.swiper-button-prev, .swiper-rtl .swiper-button-next {
  left: 6px;
}

.swiper-button-next, .swiper-rtl .swiper-button-prev {
  right: 6px;
}

.swiper {
  padding-left: 12px;
  padding-right: 12px;
}

@media (max-width: 576px) {
  .swiper-button-next, .swiper-button-prev {
    display: none;
  }
}